import React from '../../vendor/react';
import { Outlet, Link, NavLink, navigate } from '../../vendor/react-router-dom';
import { BarChart3, Building2, ClipboardList, History, LogOut, Settings, ShieldCheck } from '../../vendor/lucide-react';
import { BrandMark } from '../layout/BrandMark';
import { useAuth } from '../../features/auth/auth-store';
import { cn } from '../../lib/cn';

const links = [
  { to: '/admin', label: 'Resumen', icon: BarChart3, end: true },
  { to: '/admin/organizaciones', label: 'Organizaciones', icon: Building2 },
  { to: '/admin/planes', label: 'Planes y límites', icon: Settings },
  { to: '/admin/avisos', label: 'Avisos', icon: ClipboardList },
  { to: '/admin/soporte', label: 'Soporte auditado', icon: History },
];

export function AdminLayout() {
  const auth = useAuth();
  const logout = async () => { await auth.actions.signOut(); navigate('/ingresar', { replace: true }); };
  return <div className="admin-shell">
    <aside className="admin-sidebar">
      <div className="admin-brand"><BrandMark/><span>Panel maestro</span></div>
      <div className="admin-role"><ShieldCheck size={17}/><span>{auth.session?.user.platformRole === 'superadmin' ? 'Superadministrador' : 'Soporte'}</span></div>
      <nav>{links.map(({to,label,icon:Icon,end})=><NavLink key={to} to={to} end={end} className={({isActive})=>cn('admin-nav-link',isActive&&'is-active')}><Icon size={18}/><span>{label}</span></NavLink>)}</nav>
      <footer><Link to="/app">Abrir operación</Link><button onClick={logout}><LogOut size={17}/> Cerrar sesión</button></footer>
    </aside>
    <main className="admin-main"><header className="admin-topbar"><div><span>NEXO SaaS</span><h1>Administración de la plataforma</h1></div><strong>{auth.session?.user.email}</strong></header><div className="admin-content"><Outlet/></div></main>
  </div>;
}
